import { useQuery } from "react-query";

import { callGetMe, callListMyBuildingTree } from "../../api/me";
import { meKey } from "./meKeys";

/**
 * useQueryのラッパー: ログインユーザー詳細を取得
 */
export const useMeQuery = () => {
  return useQuery({
    queryFn: callGetMe,
    queryKey: meKey.me(),
  });
};

export const useMyBuildingTreeQuery = () => {
  return useQuery({
    queryFn: callListMyBuildingTree,
    queryKey: meKey.buldingTree(),
  });
};
